import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "u-copy-s gev19-infotext--grey u-mar-y-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_info_box = _resolveComponent("info-box")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ueberschrift, null, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createTextVNode("Vertragsunterlagen digital")
      ])),
      _: 1,
      __: [2]
    }),
    _createVNode(_component_zeile, null, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, {
          "zeige-info": !_ctx.piniaStore.state.isMakler,
          "info-box-id": "infoVertragsunterlagenDigital",
          "aria-hidden": "true"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", { innerHTML: _ctx.titelText }, null, 8, _hoisted_1)
          ]),
          _: 1
        }, 8, ["zeige-info"]),
        _createVNode(_component_zelle, { class: "mkRadio" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.standardKommunikationsart) = $event)),
              type: "radio",
              id: "standardKommunikationsartEmail",
              name: "standardKommunikationsart",
              value: "EMAIL",
              required: "",
              "aria-required": "true",
              "aria-label": "Ja, ich möchte Vertragsunterlagen digital bekommen",
              tabIndex: "0",
              "data-cy": "standardKommunikationsartEmail"
            }, null, 512), [
              [_vModelRadio, _ctx.piniaStore.state.personendaten.versicherungsnehmer.standardKommunikationsart]
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("label", {
              for: "standardKommunikationsartEmail",
              class: "radiolabel"
            }, "Ja", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.standardKommunikationsart) = $event)),
              type: "radio",
              id: "standardKommunikationsartBrief",
              name: "standardKommunikationsart",
              value: "BRIEF",
              "aria-label": "Nein, ich möchte Vertragsunterlagen per Postzustellung bekommen",
              "data-cy": "standardKommunikationsartBrief"
            }, null, 512), [
              [_vModelRadio, _ctx.piniaStore.state.personendaten.versicherungsnehmer.standardKommunikationsart]
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("label", {
              for: "standardKommunikationsartBrief",
              class: "radiolabel"
            }, "Nein", -1)),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler.standardKommunikationsart,
              "reduzierter-abstand": true
            }, null, 8, ["fehler-text"]),
            _createVNode(_component_info_box, {
              id: "infoVertragsunterlagenDigital",
              role: "tooltip",
              "aria-describedby": "infoVertragsunterlagenDigital",
              sichtbarkeit: _ctx.wechsleSichtbarkeit
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" Bitte beachten Sie, dass Sie künftig für alle Verträge die Unterlagen digital erhalten. ")
              ])),
              _: 1,
              __: [3]
            }, 8, ["sichtbarkeit"]),
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.hinweisText), 1)
          ]),
          _: 1,
          __: [4,5]
        })
      ]),
      _: 1
    })
  ], 64))
}